var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortUpper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.454298 5.47085C0.130026 5.15646 0.132361 4.63544 0.45944 4.32397L5.00008 -2.24668e-07L9.54054 4.32398C9.86761 4.63545 9.86994 5.15645 9.54567 5.47084C9.24034 5.76686 8.75614 5.77029 8.44666 5.4786L5.00008 2.23026L1.5533 5.47863C1.24381 5.7703 0.759624 5.76687 0.454298 5.47085Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUpper);
export default __webpack_public_path__ + "static/media/sortUpper.4ad0bf2342e8f7c027e8f24470668d34.svg";
export { ForwardRef as ReactComponent };